import Modal from 'components/Modal';
import Text from 'components/Text';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import shopActions from 'services/shop/actions';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';

interface ChoosePrintStationModalProps {
  open: boolean;
  onClose: () => void;
  startDate: string;
}

const ChoosePrintStationModal = ({ open, onClose, startDate }: ChoosePrintStationModalProps) => {
  const totalStation = shopSelectors.data.totalStation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const handleChooseStation = (stationNumber: number) => {
    navigate(`/store/${storage.shop_id.get()}/credit-cards/print`, { state: { stationNumber, startDate } });
    onClose();
  };

  useEffect(() => {
    if (open) {
      dispatch(shopActions.get.totalStation.fetch(storage.shop_id.get()!));
    }
  }, [open]);

  return (
    <StyledModal
      visible={open}
      onClose={onClose}
      modalTitle='Choose Print Station'
      width={900}
      centered
      hiddenOkButton
      v2
    >
      <Content>
        {Array.from({ length: totalStation }).map((_, index) => (
          <StationItem key={index} onClick={() => handleChooseStation(index + 1)}>
            <Text variant='H5'>STATION {index + 1}</Text>
          </StationItem>
        ))}
      </Content>
    </StyledModal>
  );
};

export default ChoosePrintStationModal;

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding: 40px !important;
    margin: 0 !important;
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  row-gap: 24px;
`;

const StationItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  border: 1px solid #86909c;
  border-radius: 8px;
  box-shadow:
    0 2px 4px 0 rgba(44, 35, 66, 0.4),
    0 4px 8px -3px rgba(45, 35, 66, 0.3),
    0 -3px 0 0 #d6d6e7 inset;
  background: #ffffff;
  font-family: Poppins;
  cursor: pointer;

  &:hover {
    box-shadow:
      0 4px 8px 0 rgba(44, 35, 66, 0.4),
      0 8px 16px -3px rgba(45, 35, 66, 0.3),
      0 -3px 0 0 #d6d6e7 inset;
  }
`;
